import React, { useRef, lazy } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
const bonuses = [{
  title: '7 Días para Frenar la Crisis',
  promise: 'El mapa de ruta paso a paso para detener la caída libre hoy mismo.',
  description: <>
        Un protocolo de intervención rápida con{' '}
        <strong data-id="element-72">acciones diarias atómicas</strong> para bajar la tensión y
        establecer un <em data-id="element-73">"Cese al Fuego" inmediato</em>. Sin teorías largas,
        solo resultados.
      </>,
  value: '7.999',
  image: 'https://cdn.magicpatterns.com/uploads/djExZAHQXwT1ARvWnMhxrn/7_dias_para_frenar_la_crisis.png'
}, {
  title: 'Botiquín de Emergencia',
  promise: 'Qué decir y qué hacer cuando una discusión se sale de control.',
  description: <>
        La guía táctica para <strong data-id="element-74">desescalar peleas en segundos</strong>.
        Incluye las 5 frases de <em data-id="element-75">"freno de emergencia"</em> para evitar decir
        cosas de las que te podrías arrepentir.
      </>,
  value: '7.999',
  image: 'https://cdn.magicpatterns.com/uploads/jkLGVRcS3N8SscX5qGX8s3/Botiquin_de_emergencia.png'
}, {
  title: 'Manual Táctico de Pareja',
  promise: 'Las reglas del juego para una convivencia en paz.',
  description: <>
        Cómo transformar los reproches en <strong data-id="element-76">pedidos claros</strong>. Este
        manual te enseña a <em data-id="element-77">negociar acuerdos</em> sin que nadie sienta que
        "perdió" la batalla.
      </>,
  value: '7.999',
  image: 'https://cdn.magicpatterns.com/uploads/wKApqVvyBCDqCH2Cncyjz3/Manual_tactico_de_pareja.png'
}, {
  title: 'Re-Conexión',
  promise: 'Volver a sentirse cerca, aunque hoy se sientan como extraños.',
  description: <>
        Ejercicios guiados de vulnerabilidad y{' '}
        <strong data-id="element-78">micro-citas diseñadas</strong> para reconstruir la{' '}
        <em data-id="element-79">intimidad emocional y física</em> de forma segura y sin presiones.
      </>,
  value: '7.999',
  image: 'https://cdn.magicpatterns.com/uploads/iW56oLf71hUnkM7gDbQkCd/Re-Conexion.png'
}, {
  title: 'Sinceridad Radical',
  promise: 'Limpiar los resentimientos acumulados para empezar de cero.',
  description: <>
        Un cuaderno de trabajo terapéutico para{' '}
        <strong data-id="element-80">cerrar heridas viejas</strong>. Aprende a{' '}
        <em data-id="element-81">perdonar de verdad</em> y a soltar las deudas emocionales que
        bloquean el futuro.
      </>,
  value: '7.999',
  image: 'https://cdn.magicpatterns.com/uploads/k7Qc1xACXsTdVbfQpR5WVs/Sinceridad_Radical.png'
}];
export function BonusSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full pt-32 pb-24 md:pt-40 md:pb-32 bg-[#0D002B]" data-id="element-82">
      <div className="max-w-6xl mx-auto px-6" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-24 md:mb-32" data-id="element-84">
          <div className="inline-block bg-[#E5A83B]/20 text-[#E5A83B] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-85">
            OFERTA IRRESISTIBLE
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 font-serif" data-id="element-86">
            El sistema completo para reconstruir una relación en crisis
          </h2>
          <p className="text-lg md:text-xl text-[#C4B5FD] font-sans max-w-2xl mx-auto mb-10" data-id="element-87">
            Además del protocolo principal, te llevás la{' '}
            <strong data-id="element-88">colección completa</strong> de herramientas tácticas.
          </p>
          <h3 className="text-2xl md:text-3xl font-bold text-white font-sans" data-id="element-89">
            Comprando hoy te llevas de regalo{' '}
            <span className="text-[#E5A83B]" data-id="element-90">5 BONUS</span>
          </h3>

          <div className="mt-10" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/1RTY5b2nJEd6nYQuabZoTt/Producto_principal_y_bonus.png" alt="5 Bonus - Colección completa de ebooks" className="w-full max-w-[600px] mx-auto h-auto rounded-2xl" style={{
            filter: 'drop-shadow(0 25px 50px rgba(124, 58, 237, 0.25))'
          }} data-id="element-92" />
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-93">
          {/* First row: 3 cards */}
          {bonuses.slice(0, 3).map((bonus, index) => <BonusCard key={index} bonus={bonus} index={index} isInView={isInView} data-id="element-94" />)}

          {/* Second row: 2 cards centered */}
          <div className="md:col-span-3 flex flex-col md:flex-row justify-center gap-8" data-id="element-95">
            {bonuses.slice(3, 5).map((bonus, index) => <div key={index + 3} className="w-full md:w-[calc(33.333%-1rem)]" data-id="element-96">
                <BonusCard bonus={bonus} index={index + 3} isInView={isInView} data-id="element-97" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}
function BonusCard({
  bonus,
  index,
  isInView
}: {
  bonus: any;
  index: number;
  isInView: boolean;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 30
  }} transition={{
    duration: 0.6,
    delay: index * 0.15,
    ease: 'easeOut'
  }} className="bg-[#E0D7FF] rounded-[20px] border border-white shadow-[0_10px_40px_-15px_rgba(124,58,237,0.15)] flex flex-col h-full relative overflow-hidden" data-id="element-98">
      <div className="absolute top-3 right-3 bg-[#7C3AED] text-white text-xs font-bold px-3 py-1 rounded-full z-20 shadow-md" data-id="element-99">
        BONUS #{index + 1}
      </div>

      {/* Cover image — full quality, no cropping */}
      {bonus.image && <div className="w-full bg-gradient-to-br from-[#7C3AED]/10 to-[#E5A83B]/10 pt-8 pb-6 px-6 flex justify-center" data-id="element-100">
          <img src={bonus.image} alt={bonus.title} className="w-auto h-48 md:h-56 object-contain drop-shadow-[0_15px_25px_rgba(30,10,60,0.35)]" loading="lazy" data-id="element-101" />
        </div>}

      <div className="p-6 md:p-8 flex flex-col flex-1" data-id="element-102">
        <div className="w-10 h-10 bg-[#7C3AED]/10 rounded-lg flex items-center justify-center mb-4" data-id="element-103">
          <BookOpenIcon className="w-5 h-5 text-[#7C3AED]" data-id="element-104" />
        </div>

        <h3 className="text-xl font-bold text-[#1E0A3C] mb-3 font-serif leading-snug" data-id="element-105">
          {bonus.title}
        </h3>

        <p className="text-[#7C3AED] font-semibold italic mb-4 text-sm font-sans" data-id="element-106">
          {bonus.promise}
        </p>

        <p className="text-[#3B1F6E] leading-relaxed font-sans text-sm mb-6 flex-1" data-id="element-107">
          {bonus.description}
        </p>

        <div className="mt-auto pt-5 border-t border-[#7C3AED]/20" data-id="element-108">
          <div className="flex items-center justify-between" data-id="element-109">
            <div className="flex flex-col gap-1" data-id="element-110">
              <span className="text-xs text-[#6B5B8D] line-through font-medium" data-id="element-111">
                Valor Real: ${bonus.value}
              </span>
              <span className="text-sm font-bold text-[#34D399] bg-black px-3 py-1 rounded-md inline-block w-max" data-id="element-112">
                HOY: GRATIS
              </span>
            </div>
            <ShieldCheckIcon className="w-7 h-7 text-[#7C3AED]/40" data-id="element-113" />
          </div>
        </div>
      </div>
    </motion.div>;
}